import { Route } from '@angular/router';
import { WorkflowMultiVariablesEnum } from './workflow-variables.enum';
import { ADMIN_ROUTES, canDeactivateGuard } from '@kuiper/ibusiness-core';

export const workflowVariablesRoutes: Route[] = [
  {
    path: ADMIN_ROUTES.WORKFLOW.VARIABLES,
    canDeactivate: [canDeactivateGuard],
    async loadComponent() {
      const c = await import('./workflow-variables.component');
      return c.WorkflowVariablesComponent;
    },
  },
  // Observation Category Routes
  {
    path: `${ADMIN_ROUTES.WORKFLOW.VARIABLE_DETAILS}/${WorkflowMultiVariablesEnum.OBSERVATION_CATEGORY}/:variableId`,
    async loadComponent() {
      const c =
        await import('./multi-variables-details/multi-variables-details.component');
      return c.MultiVariablesDetailsComponent;
    },
    children: [
      {
        path: '',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/observation-category/observation-category.component');
          return c.ObservationCategoryComponent;
        },
      },
      {
        path: 'add',
        canDeactivate: [canDeactivateGuard],
        async loadComponent() {
          const c =
            await import('./multi-variables-details/observation-category/observation-category-form/observation-category-form.component');
          return c.ObservationCategoryFormComponent;
        },
      },
      {
        path: ':id',
        canDeactivate: [canDeactivateGuard],
        async loadComponent() {
          const c =
            await import('./multi-variables-details/observation-category/observation-category-form/observation-category-form.component');
          return c.ObservationCategoryFormComponent;
        },
      },
    ],
  },
  // Risk Rating Routes
  {
    path: `${ADMIN_ROUTES.WORKFLOW.VARIABLE_DETAILS}/${WorkflowMultiVariablesEnum.RISK_RATING}/:variableId`,
    async loadComponent() {
      const c =
        await import('./multi-variables-details/multi-variables-details.component');
      return c.MultiVariablesDetailsComponent;
    },
    children: [
      {
        path: '',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/risk-rating/risk-rating.component');
          return c.RiskRatingComponent;
        },
      },
      {
        path: 'add',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/risk-rating/risk-rating-form/risk-rating-form.component');
          return c.RiskRatingFormComponent;
        },
      },
      {
        path: 'edit/:id',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/risk-rating/risk-rating-form/risk-rating-form.component');
          return c.RiskRatingFormComponent;
        },
      },
    ],
  },
  // Tax Routes
  {
    path: `${ADMIN_ROUTES.WORKFLOW.VARIABLE_DETAILS}/${WorkflowMultiVariablesEnum.TAX}/:variableId`,
    async loadComponent() {
      const c =
        await import('./multi-variables-details/multi-variables-details.component');
      return c.MultiVariablesDetailsComponent;
    },
    children: [
      {
        path: '',
        async loadComponent() {
          const c = await import('./multi-variables-details/tax/tax.component');
          return c.TaxComponent;
        },
      },
      {
        path: 'add',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/tax/tax-form/tax-form.component');
          return c.TaxFormComponent;
        },
      },
      {
        path: 'edit/:id',
        async loadComponent() {
          const c =
            await import('./multi-variables-details/tax/tax-form/tax-form.component');
          return c.TaxFormComponent;
        },
      },
    ],
  },
];
